export default __webpack_public_path__ + "static/soehne-web-extraleicht-kursiv-34e45a792dbf5d4324556a5c9e0677ea.woff";